import { render, staticRenderFns } from "./lecture-list-item.vue?vue&type=template&id=20e9a008&scoped=true"
import script from "./lecture-list-item.vue?vue&type=script&lang=js"
export * from "./lecture-list-item.vue?vue&type=script&lang=js"
import style0 from "./lecture-list-item.vue?vue&type=style&index=0&id=20e9a008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9a008",
  null
  
)

export default component.exports